export default __webpack_public_path__ + "static/media/ads-01.fb277481.svg";